module.exports = __webpack_public_path__ + "img/source_mg-01.bc87a3cd.png";